"use client";

import { useEffect, useState } from "react";
import Logo from "./Logo";

const STORAGE_KEY = "kv-disclaimer-accepted";

export default function DisclaimerModal() {
  const [show, setShow] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    try {
      if (localStorage.getItem(STORAGE_KEY) !== "1") {
        setShow(true);
      }
    } catch {
      setShow(true);
    }
  }, []);

  if (!mounted || !show) return null;

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {}
    setShow(false);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-ink/72 p-6 backdrop-blur-[3px]">
      <div className="flex max-h-[86vh] w-full max-w-[680px] flex-col border border-ink/20 bg-cream shadow-[0_30px_80px_rgba(20,24,28,0.4)]">
        <div className="overflow-y-auto px-[38px] pt-10 pb-6">
          <Logo size={48} className="mb-5" />
          <p className="m-0 mb-3.5 text-[11px] tracking-[0.24em] text-navy uppercase">
            Bar Council of India Rules
          </p>
          <h2 className="m-0 mb-5 font-serif text-[clamp(24px,3.6vw,32px)] leading-[1.25] font-normal">
            Disclaimer &amp; confirmation
          </h2>
          <p className="m-0 mb-4 text-[15px] leading-[1.7] text-ink/78">
            As per the rules of the Bar Council of India, we are not permitted to
            solicit work and advertise.
          </p>
          <p className="m-0 mb-4 text-[15px] leading-[1.7] text-ink/78">
            If you wish to gain more information about us for your own information
            and use, you can contact us at{" "}
            <a href="mailto:advocatekritikavirwal@gmail.com" className="hover:text-ink">
              advocatekritikavirwal@gmail.com
            </a>
            . By contacting us the user acknowledges the following:
          </p>
          <ul className="m-0 mb-[18px] flex flex-col gap-3 pl-5">
            <li className="text-[15px] leading-[1.7] text-ink/78">
              There has been no advertisement, personal communication, solicitation,
              invitation or inducement of any sort whatsoever from us or any of our
              members to solicit any work through this website;
            </li>
            <li className="text-[15px] leading-[1.7] text-ink/78">
              The user wishes to gain more information about us for his/her own
              information and use;
            </li>
            <li className="text-[15px] leading-[1.7] text-ink/78">
              The information about us is provided to the user only on his/her
              specific request and any information obtained through this website is
              completely at the user&rsquo;s volition and any transmission, receipt or
              use of this site would not create any lawyer-client relationship.
            </li>
          </ul>
          <p className="m-0 border-t border-ink/16 pt-[18px] text-sm leading-[1.7] text-ink/62">
            The information provided under this website is solely available at your
            request for informational purposes only, should not be interpreted as
            soliciting or advertisement. We are not liable for any consequence of any
            action taken by the user relying on material / information provided
            under this website. In cases where the user has any legal issues, he/she
            in all cases must seek independent legal advice.
          </p>
        </div>
        <div className="flex flex-wrap gap-3 border-t border-ink/16 bg-cream px-[38px] py-5">
          <button
            type="button"
            onClick={accept}
            className="cursor-pointer border-0 bg-navy px-7 py-3.5 font-sans text-[14.5px] font-medium text-cream transition-colors hover:bg-ink"
          >
            I agree
          </button>
          <a
            href="https://www.google.com"
            className="border border-ink/25 px-7 py-3.5 text-[14.5px] font-medium text-ink transition-colors hover:border-ink"
          >
            Decline
          </a>
        </div>
      </div>
    </div>
  );
}
